import { IntervalAction } from '../engine/IntervalAction';
import { SceneObject } from '../engine/SceneObject';
import { State } from '../engine/State';

export function getAnimationDuration(sceneOrState: SceneObject | State, animation: string): number {
  const state = sceneOrState instanceof SceneObject ? sceneOrState.stateMachine : sceneOrState;

  const animAction = state?.findById(animation)?.enterAction as IntervalAction;
  return animAction?.duration || 0;
}

export function getAnimationDurationMs(
  sceneOrState: SceneObject | State,
  animation: string
): number {
  return getAnimationDuration(sceneOrState, animation) * 1000;
}
